import { create } from 'zustand'

interface IAudioStore {
    isPlaying: boolean
    /** 브라우저 자동 재생 정책에 막혀 알림음을 못 냈는지 */
    isBlocked: boolean
    play: () => void
    stop: () => void
    setBlocked: (blocked: boolean) => void
}

export const useAudioStore = create<IAudioStore>((set) => ({
    isPlaying: false,
    isBlocked: false,
    play: () => set({ isPlaying: true }),
    stop: () => set({ isPlaying: false }),
    setBlocked: (blocked) => set({ isBlocked: blocked })
}))
